import React from "react";

interface IProps {
    size: "sm" | "md" | "lg";
}

export default function MasterCard(props: IProps) {
    const { size } = props;

    const SVGSize1 = {
        sm: "M21.5771 5.02979C25.322 5.02979 28.3584 8.02967 28.3584 11.73C28.3583 15.4302 25.322 18.4302 21.5771 18.4302C19.8982 18.4301 18.3629 17.8254 17.1787 16.8267C15.9945 17.8253 14.4591 18.4302 12.7803 18.4302C9.03566 18.43 6.00011 15.4301 6 11.73C6 8.02981 9.03559 5.03001 12.7803 5.02979C14.459 5.02979 15.9945 5.63386 17.1787 6.63232C18.3629 5.63373 19.8983 5.02981 21.5771 5.02979Z",
        md: "M28.7695 6.70654C33.7627 6.70654 37.8105 10.7064 37.8105 15.6401C37.8104 20.5738 33.7626 24.5728 28.7695 24.5728C26.5311 24.5727 24.4842 23.7675 22.9053 22.436C21.3264 23.7675 19.2795 24.5727 17.041 24.5728C12.0479 24.5728 8.00014 20.5738 8 15.6401C8 10.7064 12.0479 6.70654 17.041 6.70654C19.2794 6.70657 21.3264 7.5119 22.9053 8.84326C24.4841 7.5119 26.5312 6.70658 28.7695 6.70654Z",
        lg: "M35.9619 8.3833C42.2034 8.3833 47.2637 13.3831 47.2637 19.5503C47.2635 25.7173 42.2033 30.7163 35.9619 30.7163C33.1635 30.7163 30.6046 29.7092 28.6309 28.0444C26.6572 29.7088 24.0989 30.7163 21.3008 30.7163C15.0596 30.7161 10.0002 25.7172 10 19.5503C10 13.3832 15.0595 8.3835 21.3008 8.3833C24.0986 8.3833 26.6573 9.39019 28.6309 11.0542C30.6045 9.38978 33.1638 8.38335 35.9619 8.3833Z",
    };

    const SVGSize2 = {
        sm: "M21.5781 5.02979C25.3229 5.02987 28.3584 8.02972 28.3584 11.73C28.3583 15.4301 25.3229 18.4301 21.5781 18.4302C19.8992 18.4302 18.3639 17.8253 17.1797 16.8267C18.6368 15.5978 19.5624 13.7713 19.5625 11.73C19.5625 9.68849 18.6371 7.86122 17.1797 6.63232C18.3639 5.63379 19.8993 5.02979 21.5781 5.02979Z",
        md: "M28.7705 6.70654C33.7637 6.70654 37.8115 10.7064 37.8115 15.6401C37.8114 20.5738 33.7636 24.5728 28.7705 24.5728C26.5321 24.5727 24.4852 23.7675 22.9062 22.436C24.8492 20.7976 26.0829 18.3619 26.083 15.6401C26.083 12.9181 24.8494 10.4818 22.9062 8.84326C24.4851 7.5119 26.5322 6.70657 28.7705 6.70654Z",
        lg: "M35.9609 8.3833C42.2024 8.3833 47.2627 13.3831 47.2627 19.5503C47.2625 25.7173 42.2023 30.7163 35.9609 30.7163C33.163 30.7162 30.6044 29.7096 28.6309 28.0454C31.0596 25.9973 32.6015 22.9526 32.6016 19.5503C32.6016 16.1478 31.0598 13.1024 28.6309 11.0542C30.6044 9.39005 33.1631 8.3834 35.9609 8.3833Z",
    };

    const SVGSize3 = {
        sm: "M17.1787 6.63232C18.6363 7.86122 19.5615 9.68835 19.5615 11.73C19.5615 13.7714 18.636 15.5978 17.1787 16.8267C15.7217 15.5978 14.7969 13.7711 14.7969 11.73C14.7969 9.68864 15.7215 7.86122 17.1787 6.63232Z",
        md: "M22.9043 8.84375C24.8475 10.4822 26.0809 12.9177 26.0811 15.6396C26.0811 18.3616 24.8474 20.797 22.9043 22.4355C20.9617 20.797 19.7285 18.3612 19.7285 15.6396C19.7286 12.9181 20.9616 10.4822 22.9043 8.84375Z",
        lg: "M28.6299 11.0537C31.0592 13.1019 32.6016 16.147 32.6016 19.5498C32.6016 22.9524 31.0589 25.9968 28.6299 28.0449C26.2014 25.9968 24.6602 22.9519 24.6602 19.5498C24.6602 16.1475 26.2012 13.1019 28.6299 11.0537Z",
    };

    const width = {
        sm: 34,
        md: 46,
        lg: 58,
    };

    const height = {
        sm: 24,
        md: 32,
        lg: 40,
    };

    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={width[size]} height={height[size]} viewBox={`0 0 ${width[size]} ${height[size]}`} fill="none">
        <rect x="0.5" y="0.5" width={width[size] - 1} height={height[size] - 1} rx="3.5" fill="white"/>
        <rect x="0.5" y="0.5" width={width[size] - 1} height={height[size] - 1} rx="3.5" stroke="#F2F4F7"/>
        <path d={SVGSize1[size]} fill="#ED0006"/>
        <path d={SVGSize2[size]} fill="#F9A000"/>
        <path d={SVGSize3[size]} fill="#FF5E00"/>
      </svg>
    );
}